import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const FloatingWhatsApp: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Show tooltip after 3 seconds
      setTimeout(() => setShowTooltip(true), 3000);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    window.open('https://wa.me/551532415413?text=Olá! Gostaria de falar com o setor comercial (Gabriel) da Sol Nascente Hortaliças.', '_blank');
  };

  const hideTooltip = () => {
    setShowTooltip(false);
  };

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'}`}>
        <button
          onClick={handleClick}
          className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 animate-pulse"
        >
          <MessageCircle size={24} />
        </button>
      </div>

      {/* Tooltip */}
      {showTooltip && (
        <div className="fixed bottom-20 right-6 z-50 bg-white text-primary-800 p-4 rounded-2xl shadow-2xl max-w-xs animate-fade-in-up">
          <div className="flex items-start justify-between gap-2">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                <MessageCircle className="text-white" size={20} />
              </div>
              <div>
                <h4 className="font-semibold text-sm">Sol Nascente Hortaliças</h4>
                <p className="text-xs text-primary-600">Precisa de ajuda?</p>
              </div>
            </div>
            <button
              onClick={hideTooltip}
              className="text-primary-400 hover:text-primary-600 transition-colors duration-200"
            >
              <X size={16} />
            </button>
          </div>
          <p className="text-sm text-primary-600 mt-2">
            Fale conosco pelo WhatsApp e tire suas dúvidas sobre nossos produtos!
          </p>
          <div className="mt-3">
            <button
              onClick={handleClick}
              className="bg-green-500 hover:bg-green-600 text-white text-sm px-4 py-2 rounded-full transition-colors duration-300"
            >
              Iniciar Conversa
            </button>
          </div>
          {/* Arrow */}
          <div className="absolute bottom-0 right-8 transform translate-y-1/2 rotate-45 w-2 h-2 bg-white border-r border-b border-gray-200"></div>
        </div>
      )}
    </>
  );
};

export default FloatingWhatsApp;
